import React from 'react'

export const AppointmentPage = () => {
  return (
    <div>AppointmentPage</div>
  )
}
